// import { useEffect, useState } from "react"
import { useSelector } from "react-redux"

import TransportationItem from "./TransportationItem"

const TransportationDetails = ({directData, inWorkQ}) => {
    const activeCase = useSelector(state => state.case.activeCase) 



    // const [data, setData] = useState(null)

    // useEffect(() => {
    //     if (activeCase) {
    //         if (activeCase.case_transportation) {
    //             let obj = {...activeCase.case_transportation}

    //             setData(obj)
    //         }
            
    //     }
    // }, [activeCase])

    return <>
        {activeCase && activeCase.case_transportation && <TransportationItem itemData={activeCase.case_transportation} apiCase={'case_transportation'} inWorkQ={inWorkQ}/>}
    </>
}

export default TransportationDetails